import script from "./PersonRoleCreationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonRoleCreationModal.vue?vue&type=script&setup=true&lang=js"

import "./PersonRoleCreationModal.vue?vue&type=style&index=0&id=4018beca&lang=css"

const __exports__ = script;

export default __exports__